module.exports = __webpack_public_path__ + "media/images/no_llamar-64c828c1304e9cbddc1db87ea5df63e2.svg";